// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of HeatGain
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## HeatGain Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.HeatGain.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## HeatGain Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.HeatGain.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.HeatGain.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.HeatGain.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.HeatGain.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain Calculate
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Calculate = async (form, option) => {
  const response = await $api.post(Endpoints.HeatGain.Calculate(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain GetBuildingMaterials
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetBuildingMaterials = async (form, option) => {
  const response = await $api.get(
    Endpoints.HeatGain.GetBuildingMaterials(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain GetBuildingMaterials
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetInsulationMaterials = async (form, option) => {
  const response = await $api.get(
    Endpoints.HeatGain.GetInsulationMaterials(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain GetMetallicMaterials
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetMetallicMaterials = async (form, option) => {
  const response = await $api.get(
    Endpoints.HeatGain.GetMetallicMaterials(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// CalculateHeatGainDoubleRoomC1,
// CalculateHeatGainDoubleRoomC2,
// CalculateHeatGainDoubleRoomC3,
// AddHeatGainDoubleRoomC1,
// AddHeatGainDoubleRoomC2,
// AddHeatGainDoubleRoomC3,
// GetHeatGainDoubleRooms,
// GetHeatGainDoubleRoomById,

// ## HeatGain GetMetallicMaterials
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const CalculateHeatGainDoubleRoomC1 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.CalculateHeatGainDoubleRoomC1(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain CalculateHeatGainDoubleRoomC2
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const CalculateHeatGainDoubleRoomC2 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.CalculateHeatGainDoubleRoomC2(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain CalculateHeatGainDoubleRoomC3
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const CalculateHeatGainDoubleRoomC3 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.CalculateHeatGainDoubleRoomC3(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain AddHeatGainDoubleRoomC1
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const AddHeatGainDoubleRoomC1 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.AddHeatGainDoubleRoomC1(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain AddHeatGainDoubleRoomC2
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const AddHeatGainDoubleRoomC2 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.AddHeatGainDoubleRoomC2(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain AddHeatGainDoubleRoomC3
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const AddHeatGainDoubleRoomC3 = async (form, option) => {
  const response = await $api.post(
    Endpoints.HeatGain.AddHeatGainDoubleRoomC3(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain GetHeatGainDoubleRooms
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetHeatGainDoubleRooms = async (option) => {
  const response = await $api.get(
    Endpoints.HeatGain.GetHeatGainDoubleRooms(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain GetHeatGainDoubleRoomById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetHeatGainDoubleRoomById = async (option) => {
  const response = await $api.get(
    Endpoints.HeatGain.GetHeatGainDoubleRoomById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## HeatGain DeleteHeatGainDoubleRoom
/**
 *
 * @param {{params: { id: string }, query: object}} option
  
 * @returns
 */
export const DeleteHeatGainDoubleRoom = async (option) => {
  const response = await $api.delete(
    Endpoints.HeatGain.DeleteHeatGainDoubleRoom(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  Calculate,
  GetBuildingMaterials,
  GetInsulationMaterials,
  GetMetallicMaterials,
  CalculateHeatGainDoubleRoomC1,
  CalculateHeatGainDoubleRoomC2,
  CalculateHeatGainDoubleRoomC3,
  AddHeatGainDoubleRoomC1,
  AddHeatGainDoubleRoomC2,
  AddHeatGainDoubleRoomC3,
  GetHeatGainDoubleRooms,
  GetHeatGainDoubleRoomById,
  DeleteHeatGainDoubleRoom,
};
